export const abertoFormat = (value: string) => (value === 'A' ? 'Aberto' : 'Fechado');